(window.onload = function () {
  const targetButtonWrapper = document.querySelector(
    '.boost-pfs-filter-toolbar-top-mobile'
  );
  const targetButton = document.querySelector(
    '.boost-pfs-filter-toolbar-top-mobile-inner'
  );
  const contentWrapper = document.getElementById(
    'shopify-section-search-template-boost-pfs-filter'
  );

  const observer = new IntersectionObserver((entries) => {
    for (const e of entries) {
      console.log(e.isIntersecting);

      if (e.isIntersecting) {
        // console.log('true this');
        targetButtonWrapper.classList.add('js-adjust-position');
        MainContent.classList.add('js-adjust-p-relative');
      } else {
        // targetButtonWrapper.classList.remove('js-adjust-position');
        targetButtonWrapper.classList.remove('js-adjust-position');
        contentWrapper.classList.remove('js-adjust-p-relative');
      }
    }
  });

  // 監視したい要素をobserve
  observer.observe(document.querySelector('.gfooter'));
})();
